import { Http } from '@/lib/http';

export class DelinquencyActionsService extends Http {
  constructor() {
    super();
    this.endpoint = 'delinquency-pro/settings/delinquency-actions/';
  }

  /**
   * Retrieves a list of all actions.
   */
  getActions() {
    return this.httpClient().get(this.endpoint);
  }

  /**
   * Retrieves a paginated list of actions.
   * @param {Object} params - The query parameters { page, limit, all }.
   */
  getPaginatedActions(params) {
    return this.httpClient().get(`${this.endpoint}paginated`, { params });
  }

  /**
   * Retrieves a specific action by its ID.
   *
   * @param {String} id - The ID of the action to retrieve.
   */
  getActionById(id) {
    return this.httpClient().get(`${this.endpoint}${id}`);
  }

  /**
   * Creates a new action.
   *
   * @param {Object} payload - The action to create.
   */
  createAction(payload) {
    return this.httpClient().post(`${this.endpoint}`, payload);
  }

  /**
   * Updates an existing action.
   *
   * @param {Object} payload - The action to update.
   * @param {String} payload.id - The ID of the action to update.
   */
  updateAction(payload) {
    return this.httpClient().put(`${this.endpoint}${payload.id}`, payload);
  }

  /**
   * The `removeAction` function sends a DELETE request to a specific endpoint with the provided `id`.
   *
   * @param {String} id - The ID of the action to remove.
   */
  removeAction(id) {
    return this.httpClient().delete(`${this.endpoint}${id}`);
  }

  /**
   * The `updateActionConfiguration` function sends a PUT request to update the configuration of an
   * action with a specific ID.
   *
   * @param {String} id - The ID of the action to update.
   * @param {Object} [config={}] - The updated configuration of the action.
   */
  updateActionConfiguration(id, config = {}) {
    return this.httpClient().put(`${this.endpoint}${id}/configure`, {
      configurations: config
    });
  }

  /**
   * Reorders the actions.
   *
   * @param {String} id - The ID of the action to reorder.
   * @param {Object} payload - The payload to reorder the actions.
   */
  reorderActions(id, payload) {
    return this.httpClient().put(`${this.endpoint}${id}/reorder`, payload);
  }

  /**
   * Updates the active status of all actions.
   */
  setAllActiveStatus({ isActive }) {
    return this.httpClient().patch(`${this.endpoint}update-status`, {
      isActive
    });
  }
}
